import { TableHeader } from "@tiptap/extension-table-header"

export const CustomTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      rowType: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-row-type") || null,
        renderHTML: (attributes) => {
          if (!attributes.rowType) return {}
          return { "data-row-type": attributes.rowType }
        },
      },
    }
  },
})
